/** Arabic script ranges (incl. supplements, extended, presentation forms A and B). */
export const ARABIC_SCRIPT = new RegExp(
  '[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]',
);

/**
 * Normalise a person's name for storage and display: whitespace collapsed, Latin names in
 * title case (each word, including after a hyphen or apostrophe), Arabic (or mixed) names
 * exactly as entered.
 */
export function normalizeName(name: string | null | undefined): string {
  const v = (name ?? '').trim().replace(/\s+/g, ' ');
  if (!v || ARABIC_SCRIPT.test(v)) return v;
  return v
    .split(' ')
    .map((word) =>
      word
        .split(/([-'’])/u)
        .map((part) =>
          /[-'’]/u.test(part)
            ? part
            : part.charAt(0).toLocaleUpperCase() + part.slice(1).toLocaleLowerCase(),
        )
        .join(''),
    )
    .join(' ');
}
